<script setup lang="ts">
import { useUserStore } from '@/stores/modules/user'
import RelicCollection from './components/RelicCollection.vue'
import { ref } from 'vue'
import RelicDistill from './components/RelicDistill.vue'
import RelicBless from './components/RelicBless.vue'

const curTab = ref('bless')
</script>

<template>
  <div class="awaken-page page">
    <h2>圣物藏馆</h2>
    <el-tabs v-model="curTab" stretch>
      <el-tab-pane label="寻宝" name="bless" class="pane" lazy>
        <RelicBless class="pane-item" />
      </el-tab-pane>
      <el-tab-pane label="提炼" name="distill" class="pane" lazy>
        <RelicDistill class="pane-item" />
      </el-tab-pane>
      <el-tab-pane label="图鉴" name="collection" class="pane" lazy>
        <RelicCollection class="pane-item" />
      </el-tab-pane>
    </el-tabs>

    <FooterBar />
  </div>
</template>

<style lang="scss" scoped>
.awaken-page {
  padding-top: 20px;
  display: flex;
  flex-flow: column nowrap;
  height: 100%;
  overflow: hidden;
  .intro {
    margin-bottom: 20px;
    p {
      font-size: 14px;
      margin: 8px 0;
    }
  }
  .el-tabs {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-flow: column nowrap;
    :deep() {
      .el-tabs__content {
        flex: 1;
        .pane {
          height: 100%;
          .pane-item {
            height: 100%;
            overflow: hidden;
            display: flex;
          }
        }
      }
    }
  }
  .choice-soul {
    height: 100%;
    h2 {
      margin-top: 0;
    }
    .el-button {
      span {
        display: flex;
        flex-flow: column nowrap;
      }
    }
    .common-btn-wrap {
      margin-bottom: 10px;
    }
    .soul-item {
      h4 {
        text-align: left;
        margin: 0 0 10px 0;
      }
      p {
        font-size: 12px;
        margin: 4px 0;
      }
    }
  }
  .awaken-palace {
    display: flex;
    flex-flow: column nowrap;
    height: 100%;
    overflow: hidden;
  }
  .btn-wrap > div {
    align-items: flex-start;
    :deep() {
      .el-button:focus,
      .el-button:hover {
        background-color: unset;
      }
    }
  }
}
</style>
